import { configureStore } from '@reduxjs/toolkit';
import { inspectorReducers } from '@smx-ui-inspector/store/inspector-redux-state';

import { drawingsSliceReducer } from './drawings-slice';

export const drawingReducers = {
    ...inspectorReducers,
    drawings: drawingsSliceReducer,
};

export const store = configureStore({
    reducer: drawingReducers,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
